// 权限封装

let permission = [];
let isSuperAdmin = false;
let isAdmin = false;
export function setPermission(per = [], superAdmin, admin) {
  permission = per || [];
  isSuperAdmin = superAdmin;
  isAdmin = admin;
}

// 只允许 && 和 || 操作
export function op(expression = '') {
  const varReg = /\b[a-zA-Z_]+\b/g;
  const validReg = /^[a-zA-Z_&|\s()!]*$/;
  if (validReg.test(expression)) {
    const vars = expression.match(varReg);
    const args = vars.map((varKey) => {
      if (varKey === '_superAdmin') {
        return isSuperAdmin;
      }
      if (varKey === '_admin') {
        return isAdmin;
      }
      return ( isSuperAdmin || isAdmin ) ? true : permission.includes(varKey);
    });
    // eslint-disable-next-line no-new-func
    const fn = new Function(...vars, `return ${expression}`);
    let result = false;
    try {
      result = fn(...args);
    } catch (e) {
      console.error(e);
    }
    return result;
  }

  console.error('非法的权限表达式:', expression);
  return false;
}
